import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
const Passthrough = ({ children }) => children;
export const bootstrapSpaApplication = ({ children, rootElement = document.getElementById('root'), ErrorBoundary = Passthrough, }) => {
    if (!rootElement) {
        throw new Error('Root element not found');
    }
    createRoot(rootElement).render(_jsx(StrictMode, { children: _jsx(ErrorBoundary, { children: children }) }));
};
